module.exports = __webpack_public_path__ + "img/galeri.631cf467.png";